export const formatDateToDDMMMYYYY = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day}${month}${year}`;
  };

/**
 * "12 Sep 2026, 14:05" from whatever the field happens to hold — a Firestore
 * Timestamp, an ISO string, or a Date.
 *
 * Returns "" for anything unusable, INCLUDING the gap a `serverTimestamp()`
 * leaves: between the local write and the server's acknowledgement the field is
 * null, so a just-uploaded document has no time yet. Callers render their own
 * "just now" for that case rather than "Invalid Date".
 */
export const formatTimestamp = (value) => {
  if (!value) return '';
  const date = typeof value?.toDate === 'function' ? value.toDate() : new Date(value);
  return Number.isNaN(date.getTime())
    ? ''
    : date.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
};
